/**
 * 3 Steps Section
 * Desktop: Autoplay cycles through steps when in view. Click to activate.
 * Mobile: All steps stacked, no interaction needed.
 */

class ThreeSteps {
  constructor(element) {
    this.element = element;
    this.steps = Array.from(element.querySelectorAll('.three-steps__step'));
    this.totalSteps = this.steps.length;
    this.activeIndex = 0;

    // Autoplay
    this.autoplayInterval = null;
    const speedAttr = parseInt(element.dataset.autoplaySpeed, 10);
    this.autoplayDelay = (!isNaN(speedAttr) && speedAttr > 0) ? speedAttr * 1000 : 4000;

    this.initialize();
  }

  initialize() {
    if (this.totalSteps === 0) return;

    this.setActiveStep(0);

    this.steps.forEach((step, index) => {
      step.addEventListener('click', () => {
        if (index !== this.activeIndex) {
          this.stopAutoplay();
          this.setActiveStep(index);
        }
      });
    });

    this.setupAutoplayObserver();
  }

  setActiveStep(index) {
    if (index < 0 || index >= this.totalSteps) return;
    this.activeIndex = index;
    this.steps.forEach((step, i) => {
      step.classList.toggle('is-active', i === index);
    });
  }

  setupAutoplayObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.startAutoplay();
          } else {
            this.stopAutoplay();
          }
        });
      },
      { threshold: 0.05 }
    );
    observer.observe(this.element);
    this.autoplayObserver = observer;
  }

  startAutoplay() {
    if (this.autoplayInterval || this.totalSteps <= 1) return;
    this.autoplayInterval = setInterval(() => {
      const nextIndex = (this.activeIndex + 1) % this.totalSteps;
      this.setActiveStep(nextIndex);
    }, this.autoplayDelay);
  }

  stopAutoplay() {
    if (!this.autoplayInterval) return;
    clearInterval(this.autoplayInterval);
    this.autoplayInterval = null;
  }

  destroy() {
    this.stopAutoplay();
    if (this.autoplayObserver) this.autoplayObserver.disconnect();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initThreeSteps);
} else {
  initThreeSteps();
}

function initThreeSteps() {
  document.querySelectorAll('.section-three-steps').forEach((section) => {
    if (!section.threeSteps) {
      section.threeSteps = new ThreeSteps(section);
    }
  });
}

document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector?.('.section-three-steps') || e.target;
  if (!section.classList?.contains('section-three-steps')) return;
  if (section.threeSteps) {
    section.threeSteps.destroy();
    section.threeSteps = null;
  }
  section.threeSteps = new ThreeSteps(section);
});

document.addEventListener('shopify:section:unload', (e) => {
  const section = e.target.querySelector?.('.section-three-steps') || e.target;
  if (section.threeSteps) {
    section.threeSteps.destroy();
    section.threeSteps = null;
  }
});

document.addEventListener('shopify:block:select', (e) => {
  const section = e.target.closest('.section-three-steps');
  if (!section?.threeSteps) return;
  const steps = Array.from(section.querySelectorAll('.three-steps__step'));
  const index = steps.indexOf(e.target.closest('.three-steps__step'));
  if (index >= 0) {
    section.threeSteps.setActiveStep(index);
  }
});
